export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">
          联系我们
        </h2>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-5">
              <i className="ri-mail-send-line text-3xl text-accent-600"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-800 mb-3">资源投稿与商务合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md mx-auto">
              如您有优质在线视频网站资源推荐或商务合作意向，欢迎通过以下方式与我们取得联系。国产91视频期待与久久视频、芒果视频、97视频、丝瓜视频等视频播放器在线看视频站点共同发展。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 text-center">
              <i className="ri-mail-line text-2xl text-primary-500 mb-3 block"></i>
              <span className="text-xs text-foreground-500 mb-1 block">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-700">contact@国产91.com</span>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 text-center">
              <i className="ri-wechat-line text-2xl text-accent-500 mb-3 block"></i>
              <span className="text-xs text-foreground-500 mb-1 block">微信公众号</span>
              <span className="text-sm font-medium text-foreground-700">国产91视频平台</span>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 text-center">
              <i className="ri-feedback-line text-2xl text-secondary-600 mb-3 block"></i>
              <span className="text-xs text-foreground-500 mb-1 block">反馈建议</span>
              <span className="text-sm font-medium text-foreground-700">在线提交反馈</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}